var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Group } from "three";
import { OBJLoader } from "../../external/obj";
import { FileLoader } from "./FileLoader";
import { MTLLoader } from "../../external/mtl";
/**
 * Our implementation of loading OBJ files from remote endpoints.
 */
export class ObjLoader {
    static load(url, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = `${url}/../`;
            let materials;
            try {
                const mtlUrl = url.replace(ObjLoader.REPLACE_REGEX, ".mtl");
                const mtl = yield FileLoader.loadText(mtlUrl, { headers: options === null || options === void 0 ? void 0 : options.headers });
                ObjLoader.MTL_LOADER.setResourcePath(baseUrl);
                ObjLoader.MTL_LOADER.setMaterialOptions({
                    objectId: (options === null || options === void 0 ? void 0 : options.objectId) || 0,
                    clippingPlanes: options === null || options === void 0 ? void 0 : options.clippingPlanes,
                });
                materials = ObjLoader.MTL_LOADER.parse(mtl, `${mtlUrl}/../`);
            }
            catch (_a) {
                materials = null;
            }
            const obj = yield FileLoader.loadText(url, {
                headers: options === null || options === void 0 ? void 0 : options.headers,
                cacheKey: options === null || options === void 0 ? void 0 : options.cacheKey,
                cache: true,
            });
            ObjLoader.OBJ_LOADER.setMaterials(materials);
            const group = new Group();
            group.add(ObjLoader.OBJ_LOADER.parse(obj));
            return group;
        });
    }
}
ObjLoader.OBJ_LOADER = new OBJLoader();
ObjLoader.MTL_LOADER = new MTLLoader();
ObjLoader.REPLACE_REGEX = new RegExp(".obj$");
